import validator from "validator";
import message from "../../../messages/auth";

const validatePassword = (password) => {
  if (validator.isEmpty(password)) {
    return message.PASSWORD_DOSE_NOT_EXIST;
  }

  if (!password.trim().length) {
    return message.PASSWORD_DOSE_NOT_EXIST;
  }

  const regexHasNumber = /\d/g;
  if (regexHasNumber.test(password)) {
    var regexHasLetter = /[a-zA-Z]/g;
    if (regexHasLetter.test(password)) {
      return true;
    } else {
      return message.PASSWORD_MUST_HAVE_ONE_LETTER;
    }
  } else {
    return message.PASSWORD_MUST_HAVE_ONE_NUMBER;
  }
};

const validationResetPassword = (info) => {
  const resValidatePassword = validatePassword(info.password);
  if (resValidatePassword != true) {
    return resValidatePassword;
  }

  return true;
};

export default validationResetPassword;
